
export default () => ({
  show: false,
  loading: false,
  onCancel: false,
  fullPage: true,
  meeting: [],
  meetings: []
})



// WEBPACK FOOTER //
// ./src/app/tenant/meeting/details/resources/data.js